import { Input } from "@/components/ui/input"
import {
  TemperatureRanges,
  useTemperatureAlertSettings,
} from "@/hooks/useTemperatureAlertSettings"
import { useTranslation } from "react-i18next"

export const TemperatureAlertSettings = ({
  driverJid,
}: {
  driverJid: string
}) => {
  const { t } = useTranslation()
  const { enabled, isLoading, ranges, change, save } =
    useTemperatureAlertSettings(driverJid)

  if (!enabled) return null

  const field = (key: keyof TemperatureRanges, placeholder: string) => (
    <Input
      type="number"
      step="0.1"
      placeholder={placeholder}
      value={ranges[key]}
      onChange={(e) => change(key, e.target.value)}
      onBlur={save}
      disabled={isLoading}
      className="h-7 w-16 text-xs"
    />
  )

  return (
    <div className="mx-2 my-4 space-y-1.5">
      <div className="flex items-center gap-2">
        <div className="flex items-center gap-1.5">
          <span className="text-xs font-medium text-muted-foreground">T1:</span>
          {field("t1Min", t("maps.temperatureAlertSettings.min"))}
          <span className="text-xs text-muted-foreground">-</span>
          {field("t1Max", t("maps.temperatureAlertSettings.max"))}
        </div>
        <div className="flex items-center gap-1.5">
          <span className="text-xs font-medium text-muted-foreground">T2:</span>
          {field("t2Min", t("maps.temperatureAlertSettings.min"))}
          <span className="text-xs text-muted-foreground">-</span>
          {field("t2Max", t("maps.temperatureAlertSettings.max"))}
        </div>
        <span className="text-xs text-muted-foreground">°C</span>
      </div>
    </div>
  )
}
